import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import type { DataTableFilter } from "~components/DataTable/types/dataTableFilter.ts";
import SelectCountryCode from "~components/SelectCountryCode/SelectCountryCode.tsx";
import SelectPersonGender from "~components/SelectPersonGender";
import SelectPersonStatus from "~components/SelectPersonStatus";
import { TableFilter } from "~enums/tableFilter.ts";
import { PersonTableFiltersTypes } from "~pages/Persons/PersonListPage/enums/PersonTableFiltersTypes.ts";

export const useGetPersonTableFilters = (): {
  filters: DataTableFilter[];
  currentFilter: Record<string, any>;
  handleFilterChange: (updatedFilter: Record<string, any>) => void;
} => {
  const [currentFilter, setCurrentFilter] = useState<Record<string, any>>({});
  const { formatMessage } = useIntl();

  const handleFilterChange = useCallback((updatedFilter: Record<string, any>) => {
    setCurrentFilter(updatedFilter);
  }, []);
  const filters = [
    {
      filterKey: PersonTableFiltersTypes.Nationality,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectCountryCode
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.person.nationality.allOption",
          })}
        />
      ),
    },
    {
      filterKey: PersonTableFiltersTypes.Gender,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectPersonGender
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.gender.allOption",
          })}
        />
      ),
    },
    {
      filterKey: PersonTableFiltersTypes.Status,
      tableFilterType: TableFilter.Primary,
      filterElement: (props: { value: any; onChange: (value: any) => void }) => (
        <SelectPersonStatus
          onChange={props.onChange}
          value={props.value}
          placeholder={formatMessage({
            id: "dataTable.filters.person.status.allOption",
          })}
        />
      ),
    },
  ];
  return {
    filters,
    currentFilter,
    handleFilterChange,
  };
};
